import { render, staticRenderFns } from "./QuotesInfo.vue?vue&type=template&id=07e4dcee&scoped=true&"
import script from "./QuotesInfo.vue?vue&type=script&lang=js&"
export * from "./QuotesInfo.vue?vue&type=script&lang=js&"
import style0 from "./QuotesInfo.vue?vue&type=style&index=0&id=07e4dcee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e4dcee",
  null
  
)

export default component.exports